let ServerConfigs = {
     url: document.location.origin,
    // url: "http://localhost:5050",
    timeout: 30
}

export default ServerConfigs;